<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f86c6b 0%, #c33030 100%);">
            <i class="fa fa-check-square text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Contas Pagas</h4>
            <small class="text-muted small">Histórico de pagamentos e baixas</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3">
            <div class="d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border">
                <b-button-group class="mr-2">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarCsv()" v-b-tooltip.hover title="Exportar CSV">
                        <i class="fa fa-file-code-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-select class="border-0 bg-transparent font-weight-bold text-dark mr-2" style="width: auto;" v-model="tipoData" :options="optionsSituacao"/>
                    <cec-input-data ref="dt1" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="dt2" v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                </div>

                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="modal-label-premium">Nº Documento</label>
                      <b-form-input type="text" v-model="documento" placeholder="Ex: 12345" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="modal-label-premium">Cod. Controle</label>
                      <b-form-input type="text" v-model="id" placeholder="Ex: 987" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="8">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Fornecedor"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table ref="tbl" 
                    id="table-transition-example"        
                    class="mb-0 table-finance"
                    :dark="isDark"
                    primary-key="SEQUENCIA"
                    responsive  hover  small  show-empty
                    empty-text="Informe o filtro para ver os registros "
                    :busy.sync="isBusy" 
                    :sticky-header="stickyHeight"
                    :tbody-tr-class="rowClassSelecionado"
                    :items="itensFiltrados" 
                    :fields="tabelaListagem.fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    @row-clicked="clicarLinha"
                    >
      
            <template #head(DOCUMENTO)>
              <SetFilter
                label="DOCUMENTO"
                v-model="filtros.DOCUMENTO"
                :options="opcoes.DOCUMENTO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>

            <template #head(PARCELAS)>
              <SetFilter
                label="Parc."
                v-model="filtros.PARCELAS"
                :options="opcoes.PARCELAS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(ITENS)>
              <SetFilter
                label="Descrição"
                v-model="filtros.ITENS"
                :options="opcoes.ITENS"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(TIPO_BAIXA)>
              <SetFilter
                label="Tipo"
                v-model="filtros.TIPO_BAIXA"
                :options="opcoes.TIPO_BAIXA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(NOME_CLIENTE)>
              <SetFilter
                label="Fornecedor"
                v-model="filtros.NOME_CLIENTE"
                :options="opcoes.NOME_CLIENTE"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(DT_VENCAPAGAR)>
              <SetFilter
                label="Documento"
                v-model="filtros.DT_VENCAPAGAR"
                :options="opcoes.DT_VENCAPAGAR"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(DT_BAIXA)>
              <SetFilter
                label="Baixa"
                v-model="filtros.DT_BAIXA"
                :options="opcoes.DT_BAIXA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(VL_DOC)>
              <SetFilter
                label="VL. Doc"
                v-model="filtros.VL_DOC"
                :options="opcoes.VL_DOC"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(VL_PAGO)>
              <SetFilter
                label="Pago"
                v-model="filtros.VL_PAGO"
                :options="opcoes.VL_PAGO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(N_CONTA)>
              <SetFilter
                label="Conta"
                v-model="filtros.N_CONTA"
                :options="opcoes.N_CONTA"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #head(NOME_HISTORICO)>
              <SetFilter
                label="Histórico"
                v-model="filtros.NOME_HISTORICO"
                :options="opcoes.NOME_HISTORICO"
                :normalizeFn="normalize"
                :dropdown-variant="isDark ? 'dark' : 'none'"
              />
            </template>
            <template #cell(OP_TIPO_PAGAMENTO)="item">
              <b-badge pill class="px-2 py-1 shadow-xs" :variant="variantTipoPagamento(item.item.OP_TIPO_PAGAMENTO)">
                <i :class="iconeTipoPagamento(item.item.OP_TIPO_PAGAMENTO)" class="mr-1"></i>
                {{ descricaoTipoPagamento(item.item.OP_TIPO_PAGAMENTO) }}
              </b-badge>
            </template>
            <template #cell(TIPO_BAIXA)="item">
                <b-badge pill class="px-3 py-1 shadow-xs" :variant="colorirTIPO_BAIXA(item.item.TIPO_BAIXA)">{{item.item.TIPO_BAIXA}}</b-badge>
              </template>      
            <template #cell(NOME_CLIENTE)="item">
              <div class="font-weight-bold text-dark">{{ item.item.NOME_CLIENTE }}</div>
              <small class="text-muted">Cód: {{ item.item.COD_FORNEC }}</small>
            </template>      
            <template #cell(actions)="item">
              <b-button v-if="(item.item.TIPO_BAIXA === 'BAIXA')"
                    type="button" @click.stop.prevent="abrirModalEstorno(item.item)" size="sm" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Estornar" v-b-tooltip.hover >
                <i class="fa fa-times"></i>
              </b-button>
            </template>
            <template #empty>
              <div class="h-100 d-flex align-items-center justify-content-center p-5">
                <div class="text-center">
                    <i class="fa fa-search fa-3x text-muted mb-3"></i>
                    <p class="text-muted font-weight-bold">Nenhum registro encontrado para os filtros aplicados.</p>
                </div>
              </div>
            </template>

            <template #custom-foot="{ fields, items }">
              <b-tr class="bg-light font-weight-bold">
                <b-td v-for="(field, idx) in fields" :key="idx" :class="field.class">
                  <span v-if="field.key === 'DOCUMENTO'" class="text-center d-block">({{ itensFiltrados.length }})</span>
                  <span v-if="field.key === 'DT_BAIXA'" class="text-right d-block">TOTAIS:</span>
                  <span v-if="field.key === 'VL_DOC'" class="text-right text-dark">{{ vlDocRodape }}</span>
                  <span v-if="field.key === 'VL_PAGO'" class="text-right text-dark">{{ vlPagoRodape }}</span>
                </b-td>
              </b-tr>
            </template>
          </b-table>
          </div>
        </b-col>
      </b-row>
      <div>
      <!--  -----------------------------------------------------------------------------------
                                          MODAL ESTORNO 
            ----------------------------------------------------------------------------------- -->
        <b-modal ref="modal-estorno" 
            id="modal-estorno" 
            hide-header
            hide-footer
            body-class="p-0 overflow-hidden"
            content-class="border-0 shadow-lg"
            centered
            size="lg"
            @shown="focusModalEstornar()" 
        >
          <b-overlay :show="estorno.parametros.overlayBaixando" 
                      no-wrap 
                      fixed 
                      z-index="1100" 
                      spinner-variant="danger" 
                      spinner-type="border">
            <template #overlay>
              <div class="text-center bg-white p-4 rounded shadow-lg border">
                <b-icon icon="slash-circle" font-scale="3" class="text-danger mb-3" animation="pulse"></b-icon>
                <h5 class="font-weight-bold">Processando Estorno...</h5>
                <p class="text-muted mb-0">Por favor, aguarde um momento.</p>
              </div>
            </template>
          </b-overlay>

          <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #e53e3e 0%, #7d1c1c 100%) !important;">
              <div class="header-icon-wrapper mr-3 bg-white-10">
                  <i class="fa fa-reply text-white"></i>
              </div>
              <div>
                  <h5 class="mb-0 font-weight-bold text-white">Estornar Pagamento</h5>
                  <small class="text-white opacity-75">Anulação de saída financeira do caixa/banco</small>
              </div>
              <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$bvModal.hide('modal-estorno')">
                  <i class="fa fa-times fa-lg"></i>
              </b-button>
          </div>

          <div class="p-4 bg-white">
              <!-- Modal Info Bar -->
              <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
                  <b-row align-v="center">
                      <b-col md="6">
                          <small class="modal-label-premium">Fornecedor</small>
                          <h5 class="mb-0 font-weight-bold text-dark">{{estorno.dados.nomeCliente}}</h5>
                      </b-col>
                      <b-col md="3" class="border-left">
                          <small class="modal-label-premium">Documento / Parcela</small>
                          <h5 class="mb-0 font-weight-bold text-primary">{{estorno.dados.documento}} - {{estorno.dados.parcela}}</h5>
                          <small class="text-muted font-weight-bold">Pago em: {{estorno.dados.dataPagamento}}</small>
                      </b-col>
                      <b-col md="3" class="border-left text-right">
                          <small class="modal-label-premium">Valor Pago</small>
                          <h5 class="mb-0 font-weight-bold text-danger">{{formatCurrency(estorno.dados.valorPago)}}</h5>
                      </b-col>
                  </b-row>
              </div>

              <div class="modal-section-title mb-3">
                  <i class="fa fa-commenting mr-2 text-danger"></i> Justificativa do Estorno
              </div>
              <div class="p-3 bg-light rounded border mb-3 shadow-xs">
                   <label class="modal-label-premium">Motivo do Estorno <span class="text-danger">*</span></label>
                   <b-form-input 
                      ref="motivoEstorno" 
                      id="motivoEstorno" 
                      v-model="estorno.dados.motivo" 
                      :state="validouCampo_motivoEstorno"
                      placeholder="Informe detalhadamente o porquê deste estorno..."
                      class="rounded-pill shadow-xs"
                      @keydown.enter.native="estornar()"
                   ></b-form-input>
                   <small class="text-muted mt-2 d-block"><i class="fa fa-info-circle mr-1"></i> Esta ação irá reabrir o título no Contas a Pagar.</small>
              </div>

              <div class="modal-section-title mb-3">
                  <i class="fa fa-money mr-2 text-primary"></i> Resumo de Valores
              </div>
              
              <b-row>
                  <b-col md="6">
                      <div class="p-3 bg-white rounded border shadow-xs text-center h-100">
                          <small class="modal-label-premium">Valor do Documento</small>
                          <h5 class="mb-0 font-weight-bold text-dark">{{formatCurrency(estorno.dados.valorDocumento)}}</h5>
                      </div>
                  </b-col>
                  <b-col md="6">
                      <div class="p-3 bg-white rounded border shadow-sm text-center h-100 border-danger border-2">
                          <small class="modal-label-premium text-danger">Valor a Estornar</small>
                          <h4 class="mb-0 font-weight-bold text-danger">{{formatCurrency(estorno.dados.valorPago)}}</h4>
                      </div>
                  </b-col>
              </b-row>
          </div>

          <div class="modal-footer-premium p-3 bg-light border-top d-flex justify-content-between">
              <b-button variant="soft-danger" pill class="px-4 font-weight-bold" @click="$bvModal.hide('modal-estorno')">
                  CANCELAR
              </b-button>
              <b-button variant="danger" pill class="px-5 font-weight-bold shadow-sm" @click="estornar()">
                  <i class="fa fa-check-circle mr-1"></i> CONFIRMAR ESTORNO
              </b-button>
          </div>
        </b-modal>
      </div>
    </div>
    
    <!-- Modal de Confirmação para Resultados Grandes -->
    <ModalAlertaResultadoGrande
      ref="modalConfirmarResultadoGrande"
      :count="resultadoPendenteCount"
      @confirmar="confirmarCarregarResultadoGrande"
      @cancelar="cancelarCarregarResultadoGrande"
      @shown="modalConfirmacaoAberto = true"
      @hidden="modalConfirmacaoAberto = false"
    />
  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import {Money} from 'v-money'
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML'
import ModalAlertaResultadoGrande from '@/views/modal/ModalAlertaResultadoGrande.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  components: {
    VueButtonSpinner,
    ClientePesquisa,
    Money,
    SetFilter,
    ModalAlertaResultadoGrande,
    CecInputData
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    useExternalPaging: true,
    filters: [
      { key: 'DOCUMENTO', type: 'number', label: 'Documento' },
      { key: 'PARCELAS', type: 'string', label: 'Parcela' },
      { key: 'OP_TIPO_PAGAMENTO', type: 'string', label: 'Tipo Pgto' },
      { key: 'ITENS', type: 'string', label: 'Descrição' },
      { key: 'TIPO_BAIXA', type: 'string', label: 'Tipo' },
      { key: 'NOME_CLIENTE', type: 'string', label: 'Fornecedor' },
      { key: 'DT_VENCAPAGAR', type: 'date', label: 'Vencimento'},
      { key: 'DT_BAIXA', type: 'date', label: 'Pagamento'},
      { key: 'VL_DOC', type: 'number', label: 'VL. Doc'},
      { key: 'VL_PAGO', type: 'number', label: 'VL. Pago'},
      { key: 'N_CONTA', type: 'string', label: 'Conta'},
      { key: 'NOME_HISTORICO', type: 'string', label: 'Histórico'}
    ]
  })],
  data () {
    return {
      optionsSituacao: [
        { value: 'D', text: 'Data Documento' },
        { value: 'V', text: 'Data Baixa' }
      ],
      filtro: {
        avancado: false
      },
      formatoMoeda: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      pesquisa: {
        id: '',
        documento: '',
        situacao: '1',
        cliente_id: null
      },
      isLoading: false,
      status: '',
      isBusy: false,
      isBusyListagem: false,
      resultadoPendente: null,
      resultadoPendenteCount: 0,
      modalConfirmacaoAberto: false,
      estorno: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          pagoId: null,
          nomeCliente: '',
          documento: '',
          parcela: '',
          motivo: '',
          dataPagamento: 0.00,
          valorPago: 0.00,
          valorDocumento: 0.00,
          valorPago2: 0.00,
          valorDocumento2: 0.00,
          usuario: ''
        }
      },
      tabelaListagem: {
        items: [],
        fields: [
          {
            key: "DOCUMENTO",
            label: 'Documento',
            class:'align-middle text-right p-0',
            sortable: true,
            thStyle: { width: '10% !important'}
          },
          {
            key: "PARCELAS",
            label: 'Parc.',
            class:'align-middle text-center p-0',
            sortable: true ,
            thStyle: { width: '5% !important'} 
          },
          {
            key: "OP_TIPO_PAGAMENTO",
            label: 'Tipo Pgto',
            class:'align-middle text-center',
            sortable: true,
            thStyle: { width: '8% !important'}
          },
          {
            key: "TIPO_BAIXA",
            label: 'Tipo',
            class:'align-middle text-center p-0',
            sortable: true,
            thStyle: { width: '5% !important'} 
          },
          {
            key: "ITENS",
            label: 'Descrição',
            class:'align-middle  p-0',
            sortable: true,
            thStyle: { width: '15% !important'} 
          },
          {
            key: "NOME_CLIENTE",
            label: 'Fornecedor',
            class:'align-middle  p-0',
            sortable: true,
            thStyle: { width: '15% !important'}  
          },
          {
            key: "DT_VENCAPAGAR",
            label: 'Vencimento',
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "DT_BAIXA",
            label: 'Pagamento', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: 'VL_DOC', 
            class:'align-middle text-right p-0',
            label: 'Original (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'VL_PAGO', 
            class:'align-middle text-right p-0',
            label: 'Vl. Pago (R$)', 
            sortable: true,
            thStyle: { width: '10% !important'},
            formatter: (value, key, item) => 
              (value === null ? 0 : value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
          },
          {
            key: 'N_CONTA',
            label: 'Conta',
            class:'align-middle p-0',
            sortable: true,
            thStyle: { width: '8% !important'}
          },
          {
            key: 'NOME_HISTORICO',
            label: 'Histórico',
            class:'align-middle p-0',
            sortable: true,
            thStyle: { width: '12% !important'}
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'align-middle text-center p-0',
            thStyle: { width: '5% !important'} 
          }
        ]
      },
    }
  },
  
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
    vlPagoRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_BAIXA) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    vlDocRodape() {
      let auxValor = (this.itensFiltrados || []).reduce((s, i) => s + (Number(i.VL_DOC) || 0), 0)
      return auxValor ? auxValor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : '0,00'
    },
    currentPage: {
      get () {
        return this.$store.getters['pago/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("pago/SET_PAGINA_ATUAL", value);
      }
    },
    dt1: {
      get () {
        return this.$store.getters['pago/DT1']
      }, 
      set (value) {
        this.$store.commit("pago/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['pago/DT2']
      }, 
      set (value) {
        this.$store.commit("pago/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['pago/ID']
      }, 
      set (value) {
        this.$store.commit("pago/SET_ID", value);
      }
    },
    documento: {
      get () {
        return this.$store.getters['pago/DOCUMENTO']
      }, 
      set (value) {
        this.$store.commit("pago/SET_DOCUMENTO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['pago/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("pago/SET_CLIENTE_ID", value);
      }
    },
    tipoData: {
      get () {
        return this.$store.getters['pago/TIPO_DATA']
      }, 
      set (value) {
        this.$store.commit("pago/SET_TIPO_DATA", value);
      }
    },
    perPage: {
      get () {
        return this.$store.getters['pago/PER_PAGE'] || 25
      },
      set (v) {
        this.$store.commit('pago/SET_PER_PAGE', Number(v) || 25)
      }
    },
    lista: {
      get () {
        return this.$store.getters['pago/LISTA']
      }, 
      set (value) {
        this.$store.commit("pago/SET_LISTA", value);
      }
    },
    validouCampo_motivoEstorno () {      
      let retorno = null
      if (!this.estorno.dados.motivo  && this.estorno.dados.motivo === null)   { retorno = false }
      return  retorno
    },
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00';
      const val = typeof value === 'string' ? parseFloat(value) : value;
      return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    },
    limpar() {
      this.$store.commit("pago/SET_LIMPAR", null)
    },
    descricaoTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'Dinheiro'
        case '1': return 'Depósito'
        case '2': return 'Boleto'
        case '3': return 'Cheque'
        case '4': return 'Cartão'
        case '5': return 'Adiantamento'
        case '6': return 'PIX'
        default: return '-'
      }
    },
    iconeTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'fa fa-money'
        case '1': return 'fa fa-university'
        case '2': return 'fa fa-barcode'
        case '3': return 'fa fa-file-text-o'
        case '4': return 'fa fa-credit-card'
        case '5': return 'fa fa-exchange'
        case '6': return 'fa fa-mobile'
        default: return ''
      }
    },
    variantTipoPagamento(tipo) {
      let valor = String(tipo || '').trim()
      switch (valor) {
        case '0': return 'success'
        case '1': return 'info'
        case '2': return 'warning'
        case '3': return 'secondary'
        case '4': return 'primary'
        case '5': return 'indigo'
        case '6': return 'purple'
        default: return 'secondary'
      }
    },
    clicarLinha(item) {
      this.$store.commit("pago/SET_REGISTRO_SELECIONADO_ID", item.SEQUENCIA)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['pago/REGISTRO_SELECIONADO_ID']
      return item.SEQUENCIA === selId ? 'cec-row-selected' : ''
    },
    async abrirModalEstorno(titulo) {
      this.$store.commit("pago/SET_REGISTRO_SELECIONADO_ID", titulo.SEQUENCIA)
      const permissaoPayLoad = {
        login: window.localStorage.getItem('login'),
        permissao: 'AcPropReporDocPago'
      }

      try {
        this.$store.commit('controle/setAguardando', true)

        let permissaoResult = null
        try {
          permissaoResult = await this.$http.post(`api/protected/seguranca/validarPermissao`, permissaoPayLoad)
        } catch (err) {
          Tools.exibirMensagem(this.$store, 'Permissão', 'danger', err)
          return
        }

        const permissao = permissaoResult?.data?.permissao ?? null
      
        if (!permissao || permissao == false) {
          this.$store.commit('controle/setAguardando', false)
          await this.$bvModal.msgBoxOk('Usuário não autorizado a estornar !!!.', {
            title: 'Não autorizado',
            size: 'md',
            buttonSize: 'lg',
            okVariant: 'info',
            okTitle: 'OK',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
            noCloseOnEsc: true, 
            noCloseOnBackdrop: true
          })
          return
        }

        this.estorno.dados.pagoId = titulo.SEQUENCIA
        this.estorno.dados.nomeCliente = titulo.NOME_CLIENTE
        this.estorno.dados.parcela = titulo.PARCELAS
        this.estorno.dados.documento = titulo.DOCUMENTO
        this.estorno.dados.motivo = ''
        this.estorno.dados.dataPagamento = moment(String(titulo.DT_BAIXA)).format('DD/MM/YYYY')
        this.estorno.dados.valorPago = titulo.VL_PAGO
        this.estorno.dados.valorDocumento = titulo.VL_DOC
        this.estorno.dados.valorPago2 = titulo.VL_PAGO.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.estorno.dados.valorDocumento2 = titulo.VL_DOC.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})
        this.estorno.dados.usuario = titulo.USUARIO

        
        this.$refs['modal-estorno'].show()
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
      
    },
    focusModalEstornar() {
      this.$refs.motivoEstorno.focus()
    },

    colorirTIPO_BAIXA(valor) {
      switch (valor) {
        case 'BAIXA':
          return 'success'
        case 'PARCIAL':
          return 'info'
        default:
          return ''
      }
    },
    async pesquisar () {
      // Previne pesquisa se o modal de confirmação estiver aberto
      if (this.modalConfirmacaoAberto) {
        return
      }
      
      this.$store.commit('controle/setAguardando', true)
      try {
        const result = await this.$store.dispatch('pago/GET_LISTA')
        
        // Verifica se precisa de confirmação devido ao limite de registros
        if (result.needsConfirmation) {
          // Fecha o aguardando antes de exibir o modal
          this.$store.commit('controle/setAguardando', false)
          
          // Armazena os dados para uso posterior
          this.resultadoPendente = result.data
          this.resultadoPendenteCount = result.count
          
          // Exibe o modal de confirmação
          this.$refs.modalConfirmarResultadoGrande.show()
          return
        }
        
        // Resultado carregado normalmente
      } catch(err) {
        this.lista = []
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível consultar os dados solicitados' )
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },
    exportarHtml () {
      printHtmlReport({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        systemName: 'CECWeb',
        reportTitle: 'Listagem de Contas Pagas',
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: `Período: ${this.dt1} a ${this.dt2} - Tipo: ${this.tipoData === 'D' ? 'Data Documento' : 'Data Baixa'}`,
        pageSize: 'A4',
        landscape: true,
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        filename: 'contas_pagas.xls'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.itensFiltrados,
        columns: this.tabelaListagem.fields,
        filename: 'contas_pagas.csv',
      });
    },
    async confirmarCarregarResultadoGrande() {
      this.$store.commit('controle/setAguardando', true)
      
      try {
        await this.$store.dispatch('pago/GET_LISTA', { skipConfirmation: true })
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'danger', 'Falha ao carregar os registros: ' + err.message)
      } finally {
        this.$store.commit('controle/setAguardando', false)
        this.resultadoPendente = null
        this.resultadoPendenteCount = 0
      }
    },
    cancelarCarregarResultadoGrande() {
      this.resultadoPendente = null
      this.resultadoPendenteCount = 0
      Tools.exibirMensagem(this.$store, 'Aviso', 'info', 'Pesquisa cancelada. Refine os filtros para reduzir o resultado.')
    },
    async estornar() {
      try {
        this.$store.commit('controle/setAguardando', true)
      
        const estornarPayload = {
          login: window.localStorage.getItem('login'),
          pagoId: this.estorno.dados.pagoId,
          motivo: this.estorno.dados.motivo
        }
        await this.$http.post('api/protected/pago/estornar', estornarPayload)
        await this.pesquisar()
        this.$refs['modal-estorno'].hide()
      } catch(err) { 
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Permissão', 'danger', 'Não foi possivel estonar o pagamento!')
        return
        
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    }
  },
  created () {
    this.$refs.edDT1?.focus()
  },
  async mounted () {
    await this.pesquisar()
    
    this.$store.commit('controle/setAguardando', false)
    this.$nextTick(() => {
      this.$refs.edDT1?.focus()
    })
  },
  created () {
    this.$refs.dt1?.focus()
  },
  async mounted () {
    await this.pesquisar()
    
    this.$store.commit('controle/setAguardando', false)
    this.$refs.dt1?.focus()
  },
  watch: {
  }
}
</script>
<style>
/********************************CABECALHO FIXO***********************/

/* Cabeçalho sticky — cobre com e sem .table-responsive */
.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  position: sticky !important;
  top: 0;
  z-index: 2;
  background-clip: padding-box;
}

/* Evita “vazar” borda quando sticky 
.b-table-sticky-header > .table.b-table,
.b-table-sticky-header .table-responsive > .table.b-table {
  border-collapse: separate;
}
*/
/* Faz o wrapper responsivo rolar verticalmente respeitando a altura calculada */
.b-table-sticky-header .table-responsive {
  max-height: inherit;   /* pega o max-height do contêiner sticky */
  overflow-y: auto;      /* cria rolagem interna da tabela */
}

/* Colunas fixas (stickyColumn) também com wrapper responsivo */
.table.b-table th.b-table-sticky-column,
.table.b-table td.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table th.b-table-sticky-column,
.b-table-sticky-header .table-responsive .table.b-table td.b-table-sticky-column {
  z-index: 3;
}

/* Destaca a linha selecionada (vence striped/dark e aplica nos <td>) */
.table.b-table tbody tr.cec-row-selected,
.table.b-table tbody tr.cec-row-selected > td {
  background-color: #c2cfd6 !important;
  color: #000000 !important;
}

/* Links/ícones continuam visíveis */
.table.b-table tbody tr.cec-row-selected a {
  color: #000000 !important;
}

/* Colunas sticky também pintadas */
.table.b-table tbody tr.cec-row-selected td.b-table-sticky-column {
  background-color: #c2cfd6 !important;
}

/* (opcional) hover da linha já selecionada */
.table.b-table tbody tr.cec-row-selected:hover > td {
  background-color: #c2cfd6 !important;
}

.b-table-sticky-header > .table.b-table > thead > tr > th,
.b-table-sticky-header .table-responsive > .table.b-table > thead > tr > th {
  background-color: #f8f9fa !important;
}

/* Estilos Premium Financeiros */
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 1.5rem;
}

.modal-section-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2d3748;
  border-bottom: 2px solid #edf2f7;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-label-premium {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6c757d;
  margin-bottom: 0.4rem;
  display: block;
}

.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.table-finance thead th {
  background-color: #f8f9fa !important;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 700;
  color: #495057;
  letter-spacing: 0.5px;
  border-top: none !important;
  border-bottom: 2px solid #dee2e6 !important;
  padding: 12px 8px !important;
}

.table-finance tbody td {
  vertical-align: middle !important;
  padding: 10px 8px !important;
  color: #4a5568;
}

.table-finance tr:hover {
  background-color: rgba(66, 153, 225, 0.05) !important;
}

.btn-soft-primary {
  background-color: rgba(32, 168, 216, 0.1);
  color: #20a8d8;
  border: none;
}
.btn-soft-primary:hover {
  background-color: #20a8d8;
  color: white;
}

.btn-soft-danger {
  background-color: rgba(248, 108, 107, 0.1);
  color: #f86c6b;
  border: none;
}
.btn-soft-danger:hover {
  background-color: #f86c6b;
  color: white;
}

.bg-soft-warning { background-color: rgba(255, 193, 7, 0.12) !important; }
.bg-soft-success { background-color: rgba(40, 167, 69, 0.12) !important; }
.bg-soft-danger { background-color: rgba(220, 53, 69, 0.12) !important; }

.list-header-premium {
  background: white;
  border-bottom: 1px solid #e2e8f0;
  padding: 1.5rem 2rem;
  margin-bottom: 1rem;
  border-radius: 1rem;
}

.card-filter-premium {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  background: #fdfdfd;
}

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.bg-white-10 {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

</style>
<style scoped>
/* Ajustes finos para aproximar o visual da tabela ao padrão de VendaListagem */
.page-col .table.table-sm th,
.page-col .table.table-sm td {
  padding: 0.22rem 0.5rem; /* menor para reduzir altura da linha */
  vertical-align: middle;
}
.page-col .table.table-sm thead th {
  background-color: transparent; /* deixa o conteúdo em branco quando em tema claro */
}
.page-col .table.table-sm tbody tr {
  background-color: transparent !important; /* evita faixas cinza */
}
.page-col .table.table-sm tbody td {
  border-bottom: 1px solid #dcdfe0; /* linha horizontal entre registros */
}
</style>



// WEBPACK FOOTER //
// src/views/movimentos/contaspagas/PagasListagem.vue